import React, {Component} from 'react';
import '../../../local_node_modules/react-select/dist/react-select.css';
import Alert from "react-s-alert";
import {Col, Label, Row, UncontrolledTooltip} from 'reactstrap';
import {validateComponent, validateField} from "../../../common/validation";
import {deepCopyObject, showAxiosError} from "../../../helper/helper";
import DefaultModal from "../DefaultModal";
import Select from "../../../local_node_modules/react-select";
import {request} from "../../../helper/APIUtils";
import {ExternalCustomerMainType} from "../../../helper/enums";
import MaskedInput from "react-text-mask";

class ExternalCustomerPanel extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: {},
            invoicePkList: [],
            despatchPkList: [],
            customerType: 2,
            filteredTaxOffices: [],
            taxOffices: [],
            externalCustomerAddressList: [],
            locationSelect : true,
            externalCustomerAddress: {
                recordId: null,
                addressName: 'MERKEZ',
                gbAlias: '',
                pkAlias: '',
                countryName: 'Türkiye',
                cityName: '',
                citySubdivisionName: '',
                webSite: '',
                email: '',
                telephone: '',
                fax: '',
                postalAddressRegion: '',
                streetName: '',
                buildingName: '',
                postalAddressRoom: '',
                postalZone: '',
                contactPerson: '',
                manualInput: null,
                notify: null
            },
            externalCustomer: {
                recordId: null,
                vknTckn: '',
                formattedName: '',
                givenName: '',
                middleName: '',
                familyName: '',
                taxOffice: '',
                city: '',
                postboxAlias: '',
                despatchPostboxAlias: '',
            }
        };
        this.isOpen = this.isOpen.bind(this);
        this.validateField = this.validateField.bind(this);
        this.validateComponent = this.validateComponent.bind(this);
        this.arrangeErrorMessage = this.arrangeErrorMessage.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.onCountryChange = this.onCountryChange.bind(this);
        this.onCityChange = this.onCityChange.bind(this);
        this.onCitySubdivisionChange = this.onCitySubdivisionChange.bind(this);
        this.onVknBlur = this.onVknBlur.bind(this);
        this.getSubdivisionsForCity = this.getSubdivisionsForCity.bind(this);
        this.getTaxOffices = this.getTaxOffices.bind(this);
        this.setPkAlias = this.setPkAlias.bind(this);
        this.fetchPkList = this.fetchPkList.bind(this);
        this.onChangeExternalCustomer = this.onChangeExternalCustomer.bind(this);
        this.onChangeExternalCustomerAddress = this.onChangeExternalCustomerAddress.bind(this);
        this.checkIfVknExists = this.checkIfVknExists.bind(this);
    }

    componentDidMount() {
        let externalCustomer = this.state.externalCustomer;
        externalCustomer["externalCustomerMainType"] = this.props.externalCustomerMainType;
        this.setState({
            externalCustomer: externalCustomer,
        });
        this.getTaxOffices();
        this.setState({locationSelect: !(externalCustomer.manualInput && externalCustomer.manualInput === 1)})
    }

    componentWillMount() {
        let externalCustomer = this.state.externalCustomer;
        externalCustomer["externalCustomerMainType"] = this.props.externalCustomerMainType;
        this.setState({
            externalCustomer: externalCustomer,
            modal: this.props.modal,
            title: this.props.title
        });
    }

    componentDidUpdate(prevProps, prevState) {
        let externalCustomer = this.state.externalCustomer;
        if (prevState.externalCustomer !== this.state.externalCustomer) {
            this.fetchPkList(this.state.externalCustomer);
        }
        if(prevProps.externalCustomerMainType !== this.props.externalCustomerMainType){
            externalCustomer["externalCustomerMainType"] = this.props.externalCustomerMainType;
        }
    }

    async getTaxOffices() {
        let self = this;
        let params = {
            url: '/customer/getTaxOffices',
            method: "post",
        };
        let result = null;
        await request(params)
            .then(function (response) {
                result = response.data
            }).catch(function (error) {
                showAxiosError(error);
            });

        self.setState({taxOffices: result});

    }

    getTaxOfficesSelectData() {
        let filteredTaxOffices = [{value: null, label: "Tümü"}];
        this.state.filteredTaxOffices = this.state.taxOffices.filter(to => to.city === this.state.externalCustomer.city)
        this.state.filteredTaxOffices.map(to => (filteredTaxOffices.push({value: to.vdName, label: to.vdName})));
        return filteredTaxOffices;
    }

    setPkAlias(type, alias) {
        this.setState({
            externalCustomerAddress: {
                ...this.state.externalCustomerAddress,
                [type]: alias
            }
        })
    }

    fetchPkList(content) {
        if (content.vknTckn) {
            let self = this;
            let params = {
                url: '/externalCustomer/fetchPkList',
                data: content.vknTckn,
                method: 'post'
            };
            request(params).then((response) => {
                let pkList = response.data;
                let invoicePkList = [];
                let despatchPkList = [];
                if (pkList.length !== 0) {
                    invoicePkList = pkList.filter(pk => pk.documentType === 'Invoice');
                    if (invoicePkList.length !== 0) {
                        self.setPkAlias('postboxAlias', invoicePkList[0].aliasName);
                    }

                    despatchPkList = pkList.filter(pk => pk.documentType === 'DespatchAdvice');
                    if (despatchPkList.length !== 0) {
                        self.setPkAlias('despatchPostboxAlias', despatchPkList[0].aliasName);
                    }
                }
                self.setState({pkList: response.data, invoicePkList, despatchPkList});
            }).catch(function (error) {
                showAxiosError(error);
            });
        }
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let result = validateField(rule, boundary, e.target.value);
        let error = this.state.error;
        error = Object.assign(error, {[id]: result});
        this.setState({error});
    }

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    onChangeExternalCustomer(e) {
        let externalCustomer = deepCopyObject(this.state.externalCustomer);
        if (e.target.name === "formattedName") {
            e.target.value = e.target.value.replace(/ +(?= )/g, '');
            externalCustomer[e.target.name] = e.target.value;
        }else{
            externalCustomer[e.target.name] = e.target.value;
        }
        this.setState({externalCustomer: externalCustomer});
    }

    onChangeExternalCustomerAddress(e) {
        let externalCustomerAddress = deepCopyObject(this.state.externalCustomerAddress);
        externalCustomerAddress[e.target.name] = e.target.value;
        this.setState({externalCustomerAddress: externalCustomerAddress});
    }

    isOpen() {
        this.props.listener(this.state.externalCustomer);
    }

    getSubdivisionsForCity(city) {
        let theCity = this.props.cities.find(obj => obj.cityName === city);
        if (theCity === undefined) {
            return [];
        }
        return theCity.subdivisions.map(subdiv => ({
            value: subdiv.name,
            label: subdiv.name
        }))
    }

    onCountryChange(e) {
        this.setState({
            externalCustomerAddress: {
                ...this.state.externalCustomerAddress,
                countryName: e.value
            }
        })
    }

    onCityChange(e) {
        this.setState({
            externalCustomerAddress: {
                ...this.state.externalCustomerAddress,
                cityName: e.value
            }
        })
    }

    onCitySubdivisionChange(e) {
        this.setState({
            externalCustomerAddress: {
                ...this.state.externalCustomerAddress,
                citySubdivisionName: e.value
            }
        })
    }

    validateComponent() {
        let result = validateComponent(this);
        this.setState({
            error: result.error
        });
        return result
    }

    defineReadableFieldName(key) {
        switch (key) {
            case 'vknTckn':
                return 'VKN/TCKN ';
            case 'formattedName':
                return 'Unvan ';
            case 'givenName' :
                return 'Adı ';
            case 'familyName' :
                return 'Soyadı ';
            case 'cityName':
                return 'Şehir ';
            case 'citySubdivisionName':
                return 'İlçe ';
            default :
                return '';
        }
    }

    arrangeErrorMessage() {
        let errorObject = deepCopyObject(this.state.error);
        let errorArray = [];
        for (let key in errorObject) {
            if (errorObject.hasOwnProperty(key)) {
                let error = {};
                if (!!errorObject[key].message) {
                    error.field = this.defineReadableFieldName(key);
                    error.message = errorObject[key].message;
                    errorArray.push(error);
                }
            }
        }

        this.setState({error: errorObject});
        return errorArray.map(error => '<strong>' + error.field + error.message + '</strong><br/>').join('')
    }

    async addAddressToCustomer() {
        let externalCustomerAddressList = deepCopyObject(this.state.externalCustomerAddressList);
        if (externalCustomerAddressList.length !== 0) {
            externalCustomerAddressList.map(a => {
                    if (JSON.stringify(a) !== JSON.stringify(this.state.externalCustomerAddress)) {
                        externalCustomerAddressList = externalCustomerAddressList.splice(0, 0);
                        externalCustomerAddressList.push(this.state.externalCustomerAddress);
                    }
                }
            )
        } else {
            externalCustomerAddressList.push(this.state.externalCustomerAddress);
        }
        await this.setState({
            externalCustomerAddressList: externalCustomerAddressList,
            externalCustomer: {
                ...this.state.externalCustomer,
                externalCustomerAddressList: externalCustomerAddressList
            }
        });
    }


    async handleCreate(e) {
        let isValid = this.validateComponent();
        if (isValid.valid) {
            await this.addAddressToCustomer();
            this.handleSubmit();
        } else {
            Alert.error(this.arrangeErrorMessage(), {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000
            });
        }
    }

    handleSubmit() {
        let self = this;
        const data = self.state.externalCustomer;
        data.customerType = this.state.customerType;
        let params = {
            url: `/externalCustomer/create`,
            data: data,
            method: 'post'
        };
        request(params)
            .then((request) => {
                let externalCustomer = request.data;
                let externalCustomerAddress = externalCustomer.externalCustomerAddressList[0];
                self.props.listener(externalCustomer, externalCustomerAddress, true, false);
            })
            .catch(function (error) {
                showAxiosError(error);
            });
    }

    onVknBlur(e) {
        let error = deepCopyObject(this.state.error);
        this.validateField(e);
        if (!!this.state.externalCustomer.vknTckn && (this.props.externalCustomerMainType === ExternalCustomerMainType.Normal)) {
            this.checkIfVknExists(this.state.externalCustomer.vknTckn);
        }
        if (e.target.value.length === 10) {
            if (error.givenName) {
                delete error.givenName;
                this.setState({error})
            }
            if (error.familyName) {
                delete error.familyName;
                this.setState({error})
            }
        }
        if (e.target.value.length === 11) {
            if (error.formattedName) {
                delete error.formattedName;
                this.setState({error})
            }
        }
    }

    checkIfVknExists(value) {
        let self = this;
        const data = value;
        let params = {
            url: `/externalCustomer/findByVknTckn`,
            data: data,
            method: 'post'
        };
        request(params).then(function (response) {
            if ((response.data && !self.state.externalCustomer.recordId) ||
                (response.data && self.state.externalCustomer.recordId && self.state.externalCustomer.recordId !== response.data.recordId)) {
                let vknTckn = {
                    valid: false,
                    message: "Bu Vkn/Tckn'li Müşteri Zaten Mevcut"
                };
                let error = deepCopyObject(self.state.error);
                error.vknTckn = vknTckn;
                self.setState({
                    error
                });
                Alert.error('Bu Vkn/Tckn\'li Müşteri Zaten Mevcut', {
                    html: true,
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                })
            }
        })
            .catch(function (error) {
                showAxiosError(error);
            });
    }

    locationSelect() {
        let locationSelect = !deepCopyObject(this.state.locationSelect);
        let manualInputObj = {
            target:{
                name: 'manualInput',
                value: locationSelect ? 0 : 1
            }
        };
        this.setState({
            locationSelect,
        }, () => this.onChangeExternalCustomerAddress(manualInputObj));
    }

    render() {

        let mixedCustomerVknTckn =[
            {label: '55555555555 (Şahıs)', value:'55555555555'},
            {label: '5555555555 (Şirket)', value:'5555555555'}
        ];

        return (
            <DefaultModal
                isOpen={this.props.modal}
                title={this.props.title}
                size={"lg"}
                confirmBtnText="Kaydet"
                cancelBtnText="İptal"
                onConfirm={(e) => this.handleCreate(e)}
                onCancel={this.isOpen}>
                <Row>
                    <Col xs='12'>
                        <Label check className="col-sm-1 form-check-label">
                            <input type="checkbox" checked={!!((this.state.externalCustomerAddress.manualInput && this.state.externalCustomerAddress.manualInput === 1)||(this.state.externalCustomerAddress.countryName !=="Türkiye"))}
                                   onChange={() => this.locationSelect()}/>
                        </Label>
                        <label className="col-sm-11" style={{marginLeft: '-13px'}}>Şehir / İlçe bilgileri el ile girilsin</label>
                    </Col>
                </Row>
                <Row style={{margin: "0px", padding: "10px 10px 10px 5px"}}>
                    <Col xs='12' sm='12' md='12' lg='6'>
                        <Row>
                            <Col xs='5'>
                                <label className="col-form-label">VKN/TCKN: * </label>
                            </Col>
                            {(this.props.externalCustomerMainType !== ExternalCustomerMainType.DespatchMixed) ?
                                <Col xs='7' className={"form-group" + this.validateClass('vknTckn')}>
                                    <input className="form-control"
                                           type="text"
                                           maxLength="11"
                                           data-vlength="10,11"
                                           data-vdata="identifier"
                                           id="vknTckn"
                                           name="vknTckn"
                                           ref="vknTckn"
                                           onBlur={(e) => this.onVknBlur(e)}
                                           onChange={this.onChangeExternalCustomer}
                                           value={this.state.externalCustomer.vknTckn}/>
                                    {this.validateMessage("vknTckn") !== "" &&
                                    <UncontrolledTooltip placement="right" target={"vknTckn"} delay={0}>
                                        {this.validateMessage("vknTckn")}
                                    </UncontrolledTooltip>}
                                </Col>
                                :
                                <Col xs='7' className={"form-group" + this.validateClass('vknTckn')}>
                                <Select className="select-control"
                                        name="vknTckn"
                                        id="vknTckn"
                                        value={this.state.externalCustomer.vknTckn ? this.state.externalCustomer.vknTckn  : "5555555555"}
                                        clearable={false}
                                        placeholder="Seçiniz..."
                                        onChange={(e) => this.onChangeExternalCustomer({
                                            target: {
                                                value: e && e.value,
                                                name: 'vknTckn'
                                            }
                                        })}
                                        ref="vknTckn"
                                        options={mixedCustomerVknTckn}/>
                            {this.validateMessage('vknTckn') !== "" &&
                                <UncontrolledTooltip placement="right" target="vknTckn" delay={0}>
                            {this.validateMessage("vknTckn")}
                                </UncontrolledTooltip>}
                                </Col>
                            }
                        </Row>
                    </Col>
                    {(this.state.externalCustomer.vknTckn === null || this.state.externalCustomer.vknTckn.length !== 11) &&
                    <Col xs='12' sm='12' md='12' lg='6'>
                        <Row>
                            <Col xs='5'>
                                <label className="col-form-label">Unvan: * </label>
                            </Col>
                            <Col xs='7' className={"form-group" + this.validateClass('formattedName')}>
                                <input className="form-control"
                                       type="text"
                                       data-vlength="2,350"
                                       id="formattedName"
                                       name="formattedName"
                                       ref="formattedName"
                                       onBlur={(e) => this.validateField(e)}
                                       onChange={this.onChangeExternalCustomer}
                                       value={this.state.externalCustomer.formattedName}/>
                                {this.validateMessage("formattedName") !== "" &&
                                <UncontrolledTooltip placement="right" target={"formattedName"} delay={0}>
                                    {this.validateMessage("formattedName")}
                                </UncontrolledTooltip>}
                            </Col>
                        </Row>
                    </Col>
                    }
                    {this.state.externalCustomer.vknTckn !== null && this.state.externalCustomer.vknTckn.length === 11 &&
                    <Col xs='12' sm='12' md='12' lg='6'>
                        <Row>
                            <Col xs='5'>
                                <label className="col-form-label">Unvan: </label>
                            </Col>
                            <Col xs='7' className="form-group">
                                <input className="form-control"
                                       type="text"
                                       data-vlength="2,350"
                                       id="formattedName"
                                       name="formattedName"
                                       onBlur={(e) => this.validateField(e)}
                                       onChange={this.onChangeExternalCustomer}
                                       value={this.state.externalCustomer.formattedName}/>
                                {this.validateMessage("formattedName") !== "" &&
                                <UncontrolledTooltip placement="right" target={"formattedName"} delay={0}>
                                    {this.validateMessage("formattedName")}
                                </UncontrolledTooltip>}
                            </Col>
                        </Row>
                    </Col>
                    }
                    {this.state.externalCustomer.vknTckn !== null && this.state.externalCustomer.vknTckn.length === 11 &&
                    <Col xs='12' sm='12' md='12' lg='6'>
                        <Row>
                            <Col xs='5'>
                                <label className="col-form-label">Adı: * </label>
                            </Col>
                            <Col xs='7' className={"form-group" + this.validateClass('givenName')}>
                                <input className="form-control"
                                       type="text"
                                       data-vlength="2,255"
                                       id="givenName"
                                       name="givenName"
                                       ref="givenName"
                                       onBlur={(e) => this.validateField(e)}
                                       onChange={this.onChangeExternalCustomer}
                                       value={this.state.externalCustomer.givenName}/>
                                {this.validateMessage("givenName") !== "" &&
                                <UncontrolledTooltip placement="right" target={"givenName"} delay={0}>
                                    {this.validateMessage("givenName")}
                                </UncontrolledTooltip>}
                            </Col>
                        </Row>
                    </Col>
                    }
                    {(this.state.externalCustomer.vknTckn === null || this.state.externalCustomer.vknTckn.length !== 11) &&
                    <Col xs='12' sm='12' md='12' lg='6'>
                        <Row>
                            <Col xs='5'>
                                <label className="col-form-label">Adı: </label>
                            </Col>
                            <Col xs='7' className="form-group">
                                <input className="form-control"
                                       type="text"
                                       data-vlength="2,255"
                                       id="givenName"
                                       name="givenName"
                                       onBlur={(e) => this.validateField(e)}
                                       onChange={this.onChangeExternalCustomer}
                                       value={this.state.externalCustomer.givenName}/>
                                {this.validateMessage("givenName") !== "" &&
                                <UncontrolledTooltip placement="right" target={"givenName"} delay={0}>
                                    {this.validateMessage("givenName")}
                                </UncontrolledTooltip>}
                            </Col>
                        </Row>
                    </Col>
                    }
                    {this.state.externalCustomer.vknTckn !== null && this.state.externalCustomer.vknTckn.length === 11 &&
                    <Col xs='12' sm='12' md='12' lg='6'>
                        <Row>
                            <Col xs='5'>
                                <label className="col-form-label">Soyadı: * </label>
                            </Col>
                            <Col xs='7' className={"form-group" + this.validateClass('familyName')}>
                                <input className="form-control"
                                       type="text"
                                       data-vlength="2,255"
                                       id="familyName"
                                       name="familyName"
                                       ref="familyName"
                                       onBlur={(e) => this.validateField(e)}
                                       onChange={this.onChangeExternalCustomer}
                                       value={this.state.externalCustomer.familyName}/>
                                {this.validateMessage("givenName") !== "" &&
                                <UncontrolledTooltip placement="right" target={"givenName"} delay={0}>
                                    {this.validateMessage("givenName")}
                                </UncontrolledTooltip>}
                            </Col>
                        </Row>
                    </Col>
                    }
                    {(this.state.externalCustomer.vknTckn === null || this.state.externalCustomer.vknTckn.length !== 11) &&
                    <Col xs='12' sm='12' md='12' lg='6'>
                        <Row>
                            <Col xs='5'>
                                <label className="col-form-label">Soyadı: </label>
                            </Col>
                            <Col xs='7' className="form-group">
                                <input className="form-control"
                                       type="text"
                                       data-vlength="2,255"
                                       id="familyName"
                                       name="familyName"
                                       onBlur={(e) => this.validateField(e)}
                                       onChange={this.onChangeExternalCustomer}
                                       value={this.state.externalCustomer.familyName}/>
                                {this.validateMessage("givenName") !== "" &&
                                <UncontrolledTooltip placement="right" target={"givenName"} delay={0}>
                                    {this.validateMessage("givenName")}
                                </UncontrolledTooltip>}
                            </Col>
                        </Row>
                    </Col>
                    }
                    <Col xs='12' sm='12' md='12' lg='6'>
                        <Row>
                            <Col xs='5'>
                                <label className="col-form-label">Vergi D. Şehir: </label>
                            </Col>
                            <Col xs='7' className="form-group">
                                <Select
                                    className="select-control"
                                    clearable={true}
                                    name="city"
                                    value={this.state.externalCustomer.city}
                                    placeholder="Seçiniz..."
                                    onChange={(e) => this.onChangeExternalCustomer({
                                        target: {
                                            value: (e ? e.value : null),
                                            name: "city"
                                        }
                                    })}
                                    options={this.props.cities.map(city => ({
                                        value: city.cityName,
                                        label: city.cityName
                                    }))}
                                />
                                {this.validateMessage("city") !== "" &&
                                <UncontrolledTooltip placement="right" target="city" delay={0}>
                                    {this.validateMessage("city")}
                                </UncontrolledTooltip>}
                            </Col>
                        </Row>
                    </Col>
                    <Col xs='12' sm='12' md='12' lg='6'>
                        <Row>
                            <Col xs='5'>
                                <label className="col-form-label">Vergi D.: </label>
                            </Col>
                            <Col xs='7' className="form-group">
                                <Select
                                    clearable={true}
                                    className="select-control"
                                    name="taxOffice"
                                    onBlur={() => this.validateField({
                                        target: {
                                            id: "taxOffice",
                                            dataset: {'vlength': (this.props.requiredTaxOffice ? "1,255" : "0,255")}
                                        }
                                    })}
                                    inputProps={{'vlength': (this.props.requiredTaxOffice ? "1,255" : "0,255")}}
                                    value={this.state.externalCustomer.taxOffice}
                                    placeholder="Seçiniz..."
                                    onChange={(e) => this.onChangeExternalCustomer({
                                        target: {
                                            value: (e ? e.value : null),
                                            name: "taxOffice"
                                        }
                                    })}
                                    options={this.getTaxOfficesSelectData()}
                                />
                                {this.validateMessage("taxOffice") !== "" &&
                                <UncontrolledTooltip placement="right" target="taxOffice" delay={0}>
                                    {this.validateMessage("taxOffice")}
                                </UncontrolledTooltip>}
                            </Col>
                        </Row>
                    </Col>
                    {(this.props.docType === 'EFATURA' || this.props.docType === 'EIRSALIYE') &&
                    <Col xs='12' sm='12' md='12' lg='6'>
                        <Row>
                            <Col xs='5'>
                                <label className="col-form-label">e-Fatura Alıcı Etiketi: </label>
                            </Col>
                            <Col xs='7' className="form-group">
                                <Select
                                    className="select-control"
                                    name='postboxAlias'
                                    clearable={false}
                                    value={this.state.externalCustomerAddress.postboxAlias}
                                    placeholder="Seçiniz..."
                                    onChange={(e) => this.onChangeExternalCustomerAddress({
                                        target: {
                                            value: e && e.value,
                                            name: 'postboxAlias'
                                        }
                                    })}
                                    options={this.state.invoicePkList.map(pk => ({
                                        value: pk.aliasName,
                                        label: pk.aliasName
                                    }))}
                                />
                                {this.validateMessage("postboxAlias") !== "" &&
                                <UncontrolledTooltip placement="right" target="postboxAlias" delay={0}>
                                    {this.validateMessage("postboxAlias")}
                                </UncontrolledTooltip>}
                            </Col>
                        </Row>
                    </Col>
                    }
                    {(this.props.docType === 'EFATURA' || this.props.docType === 'EIRSALIYE') &&
                    <Col xs='12' sm='12' md='12' lg='6'>
                        <Row>
                            <Col xs='5'>
                                <label className="col-form-label">e-İrsaliye Alıcı Etiketi: </label>
                            </Col>
                            <Col xs='7' className="form-group">
                                <Select
                                    className="select-control"
                                    name='despatchPostboxAlias'
                                    clearable={false}
                                    value={this.state.externalCustomerAddress.despatchPostboxAlias}
                                    placeholder="Seçiniz..."
                                    onChange={(e) => this.onChangeExternalCustomerAddress({
                                        target: {
                                            value: e && e.value,
                                            name: 'despatchPostboxAlias'
                                        }
                                    })}
                                    options={this.state.despatchPkList.map(pk => ({
                                        value: pk.aliasName,
                                        label: pk.aliasName
                                    }))}
                                />
                                {this.validateMessage("despatchPostboxAlias") !== "" &&
                                <UncontrolledTooltip placement="right" target="despatchPostboxAlias" delay={0}>
                                    {this.validateMessage("despatchPostboxAlias")}
                                </UncontrolledTooltip>}
                            </Col>
                        </Row>
                    </Col>
                    }
                    <Col xs='12' sm='12' md='12' lg='6'>
                        <Row>
                            <Col xs='5'>
                                <label className="col-form-label">Şehir: * </label>
                            </Col>
                            <Col xs='7' className={"form-group" + this.validateClass('cityName')}>
                                {(this.state.externalCustomerAddress.countryName !== "Türkiye" || !this.state.locationSelect) ?
                                    <input className="form-control"
                                           type="text"
                                           data-vlength="2,255"
                                           id="cityName"
                                           name="cityName"
                                           ref="cityName"
                                           onBlur={(e) => this.validateField(e)}
                                           onChange={this.onChangeExternalCustomerAddress}
                                           value={this.state.externalCustomerAddress.cityName}/>
                                    :
                                    <Select
                                        clearable={false}
                                        className="select-control"
                                        name="cityName"
                                        id="cityName"
                                        onBlur={() => this.validateField({
                                            target: {
                                                id: "cityName",
                                                dataset: {'vlength': "1,255"},
                                                value: this.state.externalCustomerAddress.cityName
                                            }
                                        })}
                                        inputProps={{'vdata': "cityName", 'vlength': "1,255"}}
                                        ref="cityName"
                                        value={this.state.externalCustomerAddress.cityName}
                                        placeholder="Seçiniz..."
                                        onChange={(e) => this.onCityChange(e)}
                                        options={this.props.cities.map(city => ({
                                            value: city.cityName,
                                            label: city.cityName
                                        }))}
                                    />
                                }
                                {this.validateMessage("cityName") !== "" &&
                                <UncontrolledTooltip placement="right" target={"cityName"} delay={0}>
                                    {this.validateMessage("cityName")}
                                </UncontrolledTooltip>}
                            </Col>
                        </Row>
                    </Col>
                    <Col xs='12' sm='12' md='12' lg='6'>
                        <Row>
                            <Col xs='5'>
                                <label className="col-form-label">İlçe: * </label>
                            </Col>
                            <Col xs='7' className={"form-group" + this.validateClass('citySubdivisionName')}>
                                {(this.state.externalCustomerAddress.countryName !== "Türkiye" || !this.state.locationSelect) ?
                                    <input className="form-control"
                                           type="text"
                                           data-vlength="2,255"
                                           id="citySubdivisionName"
                                           ref="citySubdivisionName"
                                           name="citySubdivisionName"
                                           onBlur={(e) => this.validateField(e)}
                                           onChange={this.onChangeExternalCustomerAddress}
                                           value={this.state.externalCustomerAddress.citySubdivisionName}/>
                                    :
                                    <Select
                                        clearable={false}
                                        className="select-control"
                                        name="citySubdivisionName"
                                        id="citySubdivisionName"
                                        onBlur={() => this.validateField({
                                            target: {
                                                id: "citySubdivisionName",
                                                dataset: {'vdata': "required", 'vlength': "1,255"},
                                                value: this.state.externalCustomerAddress.citySubdivisionName
                                            }
                                        })}
                                        inputProps={{'vdata': "citySubdivisionName", 'vlength': "1,255"}}
                                        ref="citySubdivisionName"
                                        value={this.state.externalCustomerAddress.citySubdivisionName}
                                        placeholder="Seçiniz..."
                                        onChange={(e) => this.onCitySubdivisionChange(e)}
                                        options={this.getSubdivisionsForCity(this.state.externalCustomerAddress.cityName)}
                                    />
                                }
                                {this.validateMessage("citySubdivisionName") !== "" &&
                                <UncontrolledTooltip placement="right" target={"citySubdivisionName"} delay={0}>
                                    {this.validateMessage("citySubdivisionName")}
                                </UncontrolledTooltip>}
                            </Col>
                        </Row>
                    </Col>
                    <Col xs='12' sm='12' md='12' lg='6'>
                        <Row>
                            <Col xs='5'>
                                <label className="col-form-label">Ülke: </label>
                            </Col>
                            <Col xs='7' className="form-group">
                                <Select
                                    className="select-control"
                                    name="countryName"
                                    id="countryName"
                                    inputProps={{'vdata': "required"}}
                                    value={this.state.externalCustomerAddress.countryName}
                                    placeholder="Seçiniz..."
                                    clearable={false}
                                    onChange={(e) => this.onCountryChange(e)}
                                    options={this.props.countries ? this.props.countries.map(country => ({
                                        value: country.longNameTr,
                                        label: country.longNameTr
                                    })) : [{label: 'Türkiye', value: 'Türkiye'}]}
                                />
                                {this.validateMessage("countryName") !== "" &&
                                <UncontrolledTooltip placement="right" target={"countryName"} delay={0}>
                                    {this.validateMessage("countryName")}
                                </UncontrolledTooltip>}
                            </Col>
                        </Row>
                    </Col>
                    <Col xs='12' sm='12' md='12' lg='6'>
                        <Row>
                            <Col xs='5'>
                                <label className="col-form-label">Telefon: </label>
                            </Col>
                            <Col xs='7' className="form-group">
                                <MaskedInput className="form-control"
                                             mask={['+', '9', '0', /[1-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                                             placeholder="+90__________"
                                             type="text"
                                             id="telephone"
                                             inputProps={{vdata: "phone", vlength: '0,13'}}
                                             onBlur={() => this.validateField({
                                                 target: {
                                                     id: "telephone",
                                                     dataset: {vdata: 'phone', vlength: '0,13'},
                                                     value: this.state.externalCustomerAddress.telephone
                                                 }
                                             })}
                                             name="telephone"
                                             value={this.state.externalCustomerAddress.telephone}
                                             onChange={this.onChangeExternalCustomerAddress}/>
                                {this.validateMessage("telephone") !== "" &&
                                <UncontrolledTooltip placement="right" target={"telephone"} delay={0}>
                                    {this.validateMessage("telephone")}
                                </UncontrolledTooltip>}
                            </Col>
                        </Row>
                    </Col>
                    <Col xs='12' sm='12' md='12' lg='6'>
                        <Row>
                            <Col xs='5'>
                                <label className="col-form-label">E-Posta: </label>
                            </Col>
                            <Col xs='7' className="form-group">
                                <input className="form-control"
                                       type="text"
                                       data-vlength="0,255"
                                       id="email"
                                       name="email"
                                       onBlur={(e) => this.validateField(e)}
                                       onChange={this.onChangeExternalCustomerAddress}
                                       value={this.state.externalCustomerAddress.email}/>
                                {this.validateMessage("email") !== "" &&
                                <UncontrolledTooltip placement="right" target={"email"} delay={0}>
                                    {this.validateMessage("email")}
                                </UncontrolledTooltip>}
                            </Col>
                        </Row>
                    </Col>
                    <Col xs='12' sm='12' md='12' lg='6'>
                        <Row>
                            <Col xs='5'>
                                <label className="col-form-label">Faks: </label>
                            </Col>
                            <Col xs='7' className="form-group">
                                <input className="form-control"
                                       type="text"
                                       data-vlength="0,255"
                                       id="fax"
                                       name="fax"
                                       onBlur={(e) => this.validateField(e)}
                                       onChange={this.onChangeExternalCustomerAddress}
                                       value={this.state.externalCustomerAddress.fax}/>
                                {this.validateMessage("fax") !== "" &&
                                <UncontrolledTooltip placement="right" target={"fax"} delay={0}>
                                    {this.validateMessage("fax")}
                                </UncontrolledTooltip>}
                            </Col>
                        </Row>
                    </Col>
                    <Col xs='12' sm='12' md='12' lg='6'>
                        <Row>
                            <Col xs='5'>
                                <label className="col-form-label">Mahalle/Cadde: </label>
                            </Col>
                            <Col xs='7' className="form-group">
                                <input className="form-control"
                                       type="text"
                                       data-vlength="0,255"
                                       id="streetName"
                                       name="streetName"
                                       onBlur={(e) => this.validateField(e)}
                                       onChange={this.onChangeExternalCustomerAddress}
                                       value={this.state.externalCustomerAddress.streetName}/>
                                {this.validateMessage("streetName") !== "" &&
                                <UncontrolledTooltip placement="right" target={"streetName"} delay={0}>
                                    {this.validateMessage("streetName")}
                                </UncontrolledTooltip>}
                            </Col>
                        </Row>
                    </Col>
                    <Col xs='12' sm='12' md='12' lg='6'>
                        <Row>
                            <Col xs='5'>
                                <label className="col-form-label">Bina Adı: </label>
                            </Col>
                            <Col xs='7' className="form-group" >
                                <input className="form-control"
                                       type="text"
                                       data-vlength="0,255"
                                       id="buildingName"
                                       name="buildingName"
                                       onBlur={(e) => this.validateField(e)}
                                       onChange={this.onChangeExternalCustomerAddress}
                                       value={this.state.externalCustomerAddress.buildingName}/>
                                {this.validateMessage("buildingName") !== "" &&
                                <UncontrolledTooltip placement="right" target={"buildingName"} delay={0}>
                                    {this.validateMessage("buildingName")}
                                </UncontrolledTooltip>}
                            </Col>
                        </Row>
                    </Col>
                    <Col xs='12' sm='12' md='12' lg='6'>
                        <Row>
                            <Col xs='5'>
                                <label className="col-form-label">Bina No: </label>
                            </Col>
                            <Col xs='7' className="form-group">
                                <input className="form-control"
                                       type="text"
                                       data-vlength="0,255"
                                       id="buildingNo"
                                       name="buildingNo"
                                       onBlur={(e) => this.validateField(e)}
                                       onChange={this.onChangeExternalCustomerAddress}
                                       value={this.state.externalCustomerAddress.buildingNo}/>
                                {this.validateMessage("buildingNo") !== "" &&
                                <UncontrolledTooltip placement="right" target={"buildingNo"} delay={0}>
                                    {this.validateMessage("buildingNo")}
                                </UncontrolledTooltip>}
                            </Col>
                        </Row>
                    </Col>
                    <Col xs='12' sm='12' md='12' lg='6'>
                        <Row>
                            <Col xs='5'>
                                <label className="col-form-label">Daire No: </label>
                            </Col>
                            <Col xs='7' className="form-group">
                                <input className="form-control"
                                       type="text"
                                       data-vlength="0,255"
                                       id="postalAddressRoom"
                                       name="postalAddressRoom"
                                       onBlur={(e) => this.validateField(e)}
                                       onChange={this.onChangeExternalCustomerAddress}
                                       value={this.state.externalCustomerAddress.postalAddressRoom}/>
                                {this.validateMessage("postalAddressRoom") !== "" &&
                                <UncontrolledTooltip placement="right" target={"postalAddressRoom"} delay={0}>
                                    {this.validateMessage("postalAddressRoom")}
                                </UncontrolledTooltip>}
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </DefaultModal>
        );
    }
}

export default ExternalCustomerPanel;

